import { GETTER } from '../../constants/sort';

export const getters = {
  [GETTER.GET_FILTER]: (state) => state.sortKey
};
